import React from "react";
import type { ThreadEvent } from "@/domain/threadEvent";
import { usePhotoViewer } from "@/components/photos/PhotoViewerProvider";

export function PostcardMessage({ event }: { event: ThreadEvent }) {
  const photoViewer = usePhotoViewer();

  return (
    <div className="pm-postcard-message flex w-full flex-col gap-2">
      <div className="text-muted-foreground text-xs font-medium">Postcard</div>
      {event.postcardFrontUrl ? (
        <button
          type="button"
          className="pm-postcard-front-button w-full overflow-hidden rounded-md"
          onClick={() =>
            photoViewer.open([{ url: event.postcardFrontUrl! }], 0)
          }
          aria-label="View postcard front"
        >
          <img
            src={event.postcardFrontUrl}
            alt="Postcard front"
            className="pm-postcard-front h-full w-full object-cover [image-orientation:from-image]"
            loading="lazy"
            decoding="async"
          />
        </button>
      ) : null}
      {event.text ? (
        <div className="pm-postcard-text whitespace-pre-wrap">{event.text}</div>
      ) : null}
    </div>
  );
}
